import {
  INVALID_RESPONSE_MSG,
  PHONE_NUMBER_REGEX,
  VALIDATION_PHONE_NUMBER,
} from "utils/validation";
import * as Yup from "yup";

const validation = Yup.object({
  name: Yup.string().required(INVALID_RESPONSE_MSG),
  firmName: Yup.string().required(INVALID_RESPONSE_MSG),
  email: Yup.string().required(INVALID_RESPONSE_MSG).email("Email is invalid"),
  phoneNumber: Yup.string()
    .required(INVALID_RESPONSE_MSG)
    .matches(PHONE_NUMBER_REGEX, {
      message: VALIDATION_PHONE_NUMBER,
      excludeEmptyString: true,
    }),
  feeAmount: Yup.string().nullable().required(INVALID_RESPONSE_MSG),
  brokerFeeAddedToLoan: Yup.boolean().nullable().required(INVALID_RESPONSE_MSG),
  lenderFeeAddedToLoan: Yup.boolean().nullable().required(INVALID_RESPONSE_MSG),
}).nullable();

export default validation;
